import React from 'react';
import { FunctionFactory } from 'survey-core';
import { SelfDescription } from '../quiz/describeSelf';

const describeSelfSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">🌟 </div>
  <div class="splash-header">
    <h1>You're probably doing better than you think!</h1>
    <div class="quote">
      We’ll help you spot what’s working, and show you how to build on it.
    </div>
  </div>
</div>`;

const describeSelfSplashExpression = {
  name: "describeSelfQuote",
  expression: "renderDescribeSelfSplash({describeSelf})",
};

function renderDescribeSelfSplash(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as SelfDescription) {
    case SelfDescription.DietAndTrainingNeedWork:
    case SelfDescription.SlowProgress:
      return "You're probably doing better than you think! We'll help you identify what's working and how to stick with it!";
    case SelfDescription.StruggleConsistency:
    default:
      return "";
  }
}

FunctionFactory.Instance.register("renderDescribeSelfSplash", renderDescribeSelfSplash);

const DescribeSelfSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      🔒 Locking in on your personal prediction
    </div>
  )
}

const describeSelfSplashElement = {
  visibleIf: `{describeSelf} != "${SelfDescription.StruggleConsistency}"`,
  name: 'describe-self-splash',
  type: 'html',
  html: describeSelfSplashHtml,
}

export {
  describeSelfSplashElement,
  describeSelfSplashExpression,
  DescribeSelfSplashHeader,
}
